import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tab,
  Tabs,
  Tooltip
} from "@material-ui/core";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { ESTADO_SOLICITUD_INTEGRACION, INTEGRACION_MENU_AUDITORIA, TIPO_SOLICITUD_INTEGRACION } from "../../../data/constants";
import { AfiliadoMenu } from "../../../../autorizaciones/gestionAuditoria/Menus/AfiliadoMenu";
import { AdministrarIntegracionMenu } from "./AdministrarIntegracionMenu";
import { ComplementoInformacionIntegracionMenu } from "./ComplementoInformacionIntegracionMenu";
import { DocumentacionIntegracionMenu } from "./DocumentacionIntegracionMenu";
import { DiagnosticoPracticaIntegracionMenu } from "./DiagnosticoPracticaIntegracionMenu";
import { InformacionIntegracionMenu } from "./InformacionIntegracionMenu";
import { EventAvailable, NoEncryption } from "@material-ui/icons";
import { ModalPeriodosSolicitudIntegracion } from "./ModalPeriodosSolicitudIntegracion";
import { NotasMenuIntegracion } from "../../components/NotasMenuIntegracion";
import { cleanSolicitudIntegracionSeleccionada, putLiberarSolicitudDiscapacidad } from '../../../../../actions/discapacidad/discapacidadActions';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const ModalAuditarSolicitudIntegracion = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.discapacidad
  );

  const [openModalInfoPago, setOpenModalInfoPago] = React.useState(false);

  const [selectedTab, setSelectedTab] = useState(
    INTEGRACION_MENU_AUDITORIA.AFILIADO
  );

  const handleCloseModal = () => {
    props.closeModalHandler();
    dispatch(cleanSolicitudIntegracionSeleccionada());
  };

  const disabled = props.disabled;

  return (
    <Dialog fullWidth maxWidth="lg" open={props.open} onClose={props.closeModalHandler}>
      {openModalInfoPago &&
        <ModalPeriodosSolicitudIntegracion
          open={openModalInfoPago}
          items={solicitudSeleccionada.periodos}
          solicitudSeleccionada={solicitudSeleccionada}
          idSolicitud={solicitudSeleccionada.idSolicitud}
          closeModalHandler={() => setOpenModalInfoPago(false)}
        />
      }
      <DialogTitle>
        <span style={{ float: 'left' }}>Resumen Autorización de Integración - IdSolicitud: {props.solicitud?.idSolicitud}</span>
        {(solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.AUTORIZADA
          || solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
          || solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA) &&
          <Tooltip
            title={
              <>
                <span style={{ fontSize: 16 }}>
                  {`Información Periodos`}
                </span>
              </>
            }
          >
            <IconButton
              style={{ float: 'right', padding: 0 }}
              color="inherit"
              onClick={() => {
                setOpenModalInfoPago(true);
              }}
            >
              <EventAvailable />
            </IconButton>
          </Tooltip>
        }
        {(solicitudSeleccionada?.idEstadoSolicitud ===
          ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA ||
          solicitudSeleccionada?.idEstadoSolicitud ===
          ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION) &&
          solicitudSeleccionada?.solicitudesIntegracionTomadas.length > 0 &&
          <Tooltip 
            title={
              <>
                <span sx={{
                    fontSize: 13,
                  }}>
                  {`Liberar Comprobante`}
                </span>
              </>
            }
          >
            <IconButton 
              style={{float: 'right', marginRight: 15, padding: 0}}
              color="inherit" 
              onClick={() => {                                
                dispatch( 
                  putLiberarSolicitudDiscapacidad(
                    {id: solicitudSeleccionada?.solicitudesIntegracionTomadas[0].id, idSolicitud: solicitudSeleccionada?.idSolicitud},
                    'currentUser', 
                    false, 
                    null, 
                    null, 
                    null, 
                    handleCloseModal,
                    false,                              //true,
                    {                                   //props.filtros
                      idSolicitud: solicitudSeleccionada?.idSolicitud
                    }        
                  ) 
                );
              }}
            >
              <NoEncryption />
            </IconButton>
          </Tooltip>
        }
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(_event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={INTEGRACION_MENU_AUDITORIA.AFILIADO}
            label="Afiliado"
            {...a11yProps(INTEGRACION_MENU_AUDITORIA.AFILIADO)}
          />
          <Tab
            value={INTEGRACION_MENU_AUDITORIA.DOCUMENTACION}
            label="Documentación"
            {...a11yProps(INTEGRACION_MENU_AUDITORIA.DOCUMENTACION)}
          />
          <Tab
            value={INTEGRACION_MENU_AUDITORIA.INFORMACION}
            label="Información"
            {...a11yProps(INTEGRACION_MENU_AUDITORIA.INFORMACION)}
          />
          {(solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TRANSPORTE ||
            solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO ||
            solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL) &&
            <Tab
              value={INTEGRACION_MENU_AUDITORIA.COMPLEMENTO_INFORMACION}
              label="+ Información"
              {...a11yProps(INTEGRACION_MENU_AUDITORIA.COMPLEMENTO_INFORMACION)}
            />
          }
          <Tab
            value={INTEGRACION_MENU_AUDITORIA.DIAGNOSTICO_PRACTICA}
            label="Diagnóstico / Practica"
            {...a11yProps(INTEGRACION_MENU_AUDITORIA.DIAGNOSTICO_PRACTICA)}
          />
          <Tab
            value={INTEGRACION_MENU_AUDITORIA.NOTAS}
            label="Notas"
            {...a11yProps(INTEGRACION_MENU_AUDITORIA.NOTAS)}
          />
          {!disabled &&
            <Tab
              value={INTEGRACION_MENU_AUDITORIA.ADMINISTRAR}
              label="Administrar"
              {...a11yProps(INTEGRACION_MENU_AUDITORIA.ADMINISTRAR)}
            />
          }
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.AFILIADO}
        >
          <AfiliadoMenu afiliado={solicitudSeleccionada?.afiliado} integracion={true} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.DOCUMENTACION}
        >
          <DocumentacionIntegracionMenu
            onCloseModalAuditar={props.closeModalHandler}
            disabled={disabled}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.INFORMACION}
        >
          <InformacionIntegracionMenu
            disabled={disabled}
            onCloseModalAuditar={props.closeModalHandler}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.COMPLEMENTO_INFORMACION}
        >
          <ComplementoInformacionIntegracionMenu
            disabled={disabled}
            onCloseModalAuditar={props.closeModalHandler}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.DIAGNOSTICO_PRACTICA}
        >
          <DiagnosticoPracticaIntegracionMenu
            disabled={disabled}
            onCloseModalAuditar={props.closeModalHandler}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.NOTAS}
        >
          <NotasMenuIntegracion disabled={disabled} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={INTEGRACION_MENU_AUDITORIA.ADMINISTRAR}
        >
          <AdministrarIntegracionMenu closeModalAuditar={props.closeModalHandler} />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};